import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { postMessage } from 'Lib/serviceWorkerHelper';

const useUpdatePushText = ({ loggedIn }: { loggedIn: boolean }) => {
  const { formatMessage, locale } = useIntl();

  useEffect(() => {
    if (loggedIn) {
      const swPushMessage = formatMessage({ id: 'Notification.defaultTitle' });
      postMessage('SET_NOTIFICATION_BODY', { body: swPushMessage });
    }
  }, [locale, loggedIn, formatMessage]);
};

export default useUpdatePushText;
